import axios from 'axios'

export default class Request {
    apiurl = ''
    static apiurl = ''

    static async post(url = null, data = {}) {
        try {
            return await axios.post(this.apiurl + url, { ...data, token: this.getToken() }, {
                withCredentials: true,
            }).then(v => {
                if (v.status !== 200) {
                    return { 'msg': '请求错误:' + v.status }
                } else {
                    return v.data
                }
            })
        } catch (error) {
            console.log(error);
        }

        // return axios.post(this.apiurl + url, {...data,token:this.getToken()}, {
        //     withCredentials: true,
        // }).then(r => r)
    }

    static login(data = {}) {
        return this.post(this.apiurl + '/api/login', { ...data, action: 'login', token: this.getToken() }).then(r => {
            console.log(r);
            if (r.status === 'done') {
                this.setToken(r.token)
            }
            return r
        })
    }

    static logined(func) {
        axios.post('/api/statuschk', { action: 'test', token: this.getToken() }).then(r => {
            // console.log(r.data.status )
            return func(r.data.status === 'logined')
        })
    }

    static getToken = () => {
        return localStorage.getItem('_token', null)
    }
    static setToken = token => {
        try {
            localStorage.setItem('_token', token)
            return true
        } catch (error) {
            console.log(error);
        }
    }
    static p(url = null, data = {}) {
        return fetch(url, {
            body: JSON.stringify(data), // must match 'Content-Type' header
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'include', // include, same-origin, *omit
            headers: {
                'Content-Type': 'application/json'
            },
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, cors, *same-origin
            redirect: 'error', // manual, *follow, error
            referrer: 'no-referrer', // *client, no-referrer
        })
    }
}